import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ContactAttributeRequest, ContactAttributeResponse, PageResponse } from '../models/contact-attribute.model';

@Injectable({
  providedIn: 'root'
})
export class ContactAttributeApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/contact-attributes?businessId=&page=&size= (paginado desde v1.16)
  getAttributes(businessId: number, page = 0, size = 100): Observable<ContactAttributeResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<ContactAttributeResponse>>(`${this.apiUrl}/contact-attributes`, { params })
      .pipe(map(res => res.content));
  }

  // GET /api/contact-attributes/{id}?businessId=
  getAttributeById(id: number, businessId: number): Observable<ContactAttributeResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ContactAttributeResponse>(`${this.apiUrl}/contact-attributes/${id}`, { params });
  }

  // POST /api/contact-attributes
  createAttribute(attribute: ContactAttributeRequest): Observable<ContactAttributeResponse> {
    return this.http.post<ContactAttributeResponse>(`${this.apiUrl}/contact-attributes`, attribute);
  }

  // PUT /api/contact-attributes/{id}
  updateAttribute(id: number, attribute: ContactAttributeRequest): Observable<ContactAttributeResponse> {
    return this.http.put<ContactAttributeResponse>(`${this.apiUrl}/contact-attributes/${id}`, attribute);
  }

  // DELETE /api/contact-attributes/{id}?businessId=
  deleteAttribute(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/contact-attributes/${id}`, { params });
  }
}
